import React, { Component, useState, useEffect, useContext } from "react";
import '../assets/boxicons-2.0.7/css/boxicons.min.css';
import { cx } from '@emotion/css';
import * as styles from './questionWithTextFeild.style';
import QuizIndicator from './QuizIndicator';
import Meanings from './Meanings';
import withQuizPic from './hoc/withQuizPic';
import * as styles2 from './newQuestionBox.style';
import SpeechRecognition, {
  useSpeechRecognition
} from "react-speech-recognition";


const options = {
  autoStart: false,
  continous: false
};


function ListenSpeech(props) {

  const { transcript, resetTranscript } = useSpeechRecognition();


  const [textInput, set_textInput] = useState("");
  const [quizPic, set_quizPic] = useState("");
  const [value, set_value] = useState("");







  useEffect(() => {
    resetTranscript()
    SpeechRecognition.startListening({ continuous: true });
    // console.log(transcript)
    // console.log("Now listening...");
    // return () => {
    //   SpeechRecognition.stopListening();
    //   console.log("Stopped Listening");
    // };
  }, []);

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    alert("Browser does not support speech to text");
  }



















































  return (
    <div>
      <h2 className={cx(styles.title)}>
        <span>Q{props.questionnumber}/</span>
        {props.questionCount}
      </h2>




      <div className={cx(styles.questions)}>{props.question}</div>



      <img className={cx(styles.img)} src={quizPic} alt="" />

      <QuizIndicator
        questionCount={props.questionCount}
        questionnumber={props.questionnumber}
      />


      <div>
        <div className={cx(styles.iconGroup)}>
          {props.audio != "" && (
            <img
              src="../assets/redphone.png"
              alt=""
              className="card1-img-top"
            // onClick={this.handleListen}

            />
          )
          }





        </div>




        <div className={cx(styles.answers)}>
          <div className="s-title">Answer </div>
          <div>
            <input
              id={props.questionno}
              type="text"
              placeholder="Enter answer here ..."
              spellCheck="false"
              autoComplete="false"
              autoFocus={true}
              value={transcript}
              className={cx(styles.input)}
            // readonly="readonly"


            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListenSpeech